<template>
    <v-card variant="elevated" :title="t('users')" class="mx-auto dash-card" width="210">
        <template v-slot:append>
            <svg-icon type="mdi" :path="mdiAccountMultiple" class="mr-2"></svg-icon>
        </template>
        <v-card-text>    
            <p>{{ userMessage }}</p>
        </v-card-text>
    </v-card>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiAccountMultiple } from '@mdi/js';
import { useI18n } from 'vue-i18n';

const store = useStore();
const dashboardStatistics = ref({ totalUsers: 0, uniqueAccounts: 0 });
const { t } = useI18n();

onMounted(async () => {
    await store.dispatch('dashboard/fetchDashboardStatistics'); // Fetch statistics on component mount
    dashboardStatistics.value = store.state.dashboard.dashboardStatistics; // Bind the statistics
});

// Here's the computed property for the user message
const userMessage = computed(() => {
    const currentUserRole = localStorage.getItem('role') || '';
    const { totalUsers = 0, uniqueAccounts = 0 } = dashboardStatistics.value || {};

    console.log(`Current User Role: ${currentUserRole}, Total Users: ${totalUsers}, Unique Accounts: ${uniqueAccounts}`);

    // Conditional message based on role and user count
    if (currentUserRole === 'super') {
        if (totalUsers === 1) {
            return `${t('oneRegistered')} ${t('user')} ${t('on')} ${uniqueAccounts} ${t('accounts')}.`;
        } else if (uniqueAccounts === 1) {
            return `${totalUsers} ${t('user')} ${t('on')} ${uniqueAccounts} ${t('accounts')}.`;
        } else {
            return `${totalUsers} ${t('users')} ${t('on')} ${uniqueAccounts} ${t('accounts')}.`;
        }
    } else {
        if (totalUsers === 1) {
            return `1 ${t('user')}.`;
        } else {
            return `${totalUsers} ${t('users')}.`;
        }
    }
});
</script>

<style>

a {
    text-decoration: none;
    display: inline-block;
    width: 100%;
}

.dash-card {
    background-color: #f5f5f5;
    border-radius: 8px;
    padding: 3px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    text-decoration: none;
    transition: transform 0.2s;
    cursor: pointer;
}
</style>